// extracted by mini-css-extract-plugin
export default {"modalFooter":"ExternalProjectBulkImport-module__modalFooter___FeqSa","selectedCount":"ExternalProjectBulkImport-module__selectedCount___lluXy"};